import {gql} from '@apollo/client';

export default gql`
  mutation createPixelEventRecord($input: CreatePixelEventRecordInput!) {
    authed {
      success
    }
    createPixelEventRecord(input: $input) {
      pixelEventRecord {
        id
        name
        eventType
        installation
        lastUpdatedBy {
          id
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
    }
  }
`;
